/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Mon Apr 15 2024 11:27:24
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import AiBasedAlgorithm from './ai-based-algorithm';

import {
  PERSONALIZED_RECOMMENDATION,
  RECOMMENDATION_AI_BASED_PERSONALIZED_SECONDARY_OPTIONS,
  RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES
} from 'src/constants/recommendation';

type Props = WithI18nProps & {
  formValues: RecommendationWidgetType,
  updateField: Function,
  host: string,
  aimlPermission: boolean,
  syncOrderStatus: {},
  AIBasedRecommendProduct: string
};

class PersonalizedRecommendation extends Component<Props> {
  render() {
    const { i18n, updateField, AIBasedRecommendProduct, secondaryAlgorithm } = this.props;

    return (
      <div className="widget-based-section">
        <div className="general-items">
          <Heading>
            {i18n.translate(
              'AdminHTML.Recommendation.WidgetItem.widgetAIBasedMethodSection_Label',
              { index: '' }
            )}
          </Heading>
          <div className="widget-details-block">
            <AiBasedAlgorithm
              updateField={updateField}
              type={RECOMMENDATION_WIDGET_RECOMMENDATION_TYPES[PERSONALIZED_RECOMMENDATION].value}
              primaryDisabled={true}
              primaryOptions={RECOMMENDATION_AI_BASED_PERSONALIZED_SECONDARY_OPTIONS}
              primaryAlgorithm={AIBasedRecommendProduct}
              secondaryAlgorithm={secondaryAlgorithm}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default withI18n()(PersonalizedRecommendation);
